import { getOrderList, getOrderDetail, createOrder, cancelOrder } from '@/api/modules/order'

const state = {
  orderList: [],
  orderDetail: null,
  total: 0
}

const getters = {
  orderList: state => state.orderList,
  orderDetail: state => state.orderDetail,
  total: state => state.total
}

const mutations = {
  SET_ORDER_LIST(state, { list, total }) {
    state.orderList = list
    state.total = total
  },
  SET_ORDER_DETAIL(state, detail) {
    state.orderDetail = detail
  }
}

const actions = {
  async fetchOrderList({ commit }, params) {
    const res = await getOrderList(params)
    commit('SET_ORDER_LIST', { list: res.data.list, total: res.data.total })
    return res
  },

  async fetchOrderDetail({ commit }, id) {
    const res = await getOrderDetail(id)
    commit('SET_ORDER_DETAIL', res.data)
    return res
  },

  async createOrder({ dispatch }, data) {
    const res = await createOrder(data)
    dispatch('fetchOrderList', { page: 1 })
    return res
  },

  async cancelOrder({ dispatch }, id) {
    await cancelOrder(id)
    dispatch('fetchOrderList', { page: 1 })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
